<div class="profile-container">
    <div class="">
        <div class="profile-content">
            <div class="personal-details">

              <div class="header-block">
                  <div class="header-title">
                    <app-breadcrumb></app-breadcrumb>
                  </div>
                  <div class="add-block">
                    <div class="search">
                      <form autocomplete="off" >
                        <input type="text" placeholder="search" (keyup.enter)="getBranchMastersByWildSearchKey()" [ngModelOptions]="{standalone: true}" [(ngModel)]="searchFilter">
                      </form>
                      <i class="bi bi-search" (click)="getBranchMastersByWildSearchKey()"></i>
                    </div>
                    <button *ngIf="actionControls.isAdd" title="Add" data-toggle="modal" data-target="#exampleModal"><i class="bi bi-plus-lg"></i> {{ 'generic.add' | translate }}</button>
                    <div class="filter-icon">
                      <i class="bi bi-arrow-clockwise" title="Refresh" (click)="refreshAll()"></i>
                    </div>
                  </div>
              </div>
            
              <table class="table table-striped">
                  <thead>
                      <tr>
                        <th style="width: 30%;">{{ 'branch-master.name' | translate }}</th>
                        <th style="width: 30%;">{{ 'branch-master.description' | translate }}</th>
                        <th style="width: 20%;">{{ 'branch-master.internal' | translate }}</th>
                        <th style="width: 20%;;text-align: center;padding: 0;">{{ 'generic.action' | translate }}</th>
                      </tr>
                  </thead>
              </table>
              <div *ngIf="!isLoading">
                  <div class="data-view" id="{{list.id}}" [ngClass]="{ 'delete-highlight': list.branchMasterId == recordId }" *ngFor="let list of product | paginate : {
                      itemsPerPage: tableSize,
                      currentPage: pageNumber,
                      totalItems: totalRecords
                      }  ;let i = index">
      
                      <p style="width: 30%;">{{list.name}}</p>
                      <p style="width: 30%;">{{list.description}}</p>            
                      <p style="width: 20%;">{{list.internal}}</p>            
                      <p class="action-buttons" style="width: 20%;padding-left: 25px;">
                        <i data-toggle="modal" title="View" (click)="getBranchById(list.branchMasterId)" data-target="#viewModal" class="bi bi-eye-fill"></i>

                        <i *ngIf="actionControls.isDelete" title="Delete" class="bi bi-trash3" (click)="selectId(list.id,list)" data-toggle="modal" data-target="#deleteModal"></i>
                      </p>
                  </div>
              </div>
      
      
              <div class="loader" *ngIf="isLoading">
                  <div class="spinner"></div>
              </div>
      
              <div class="loader"  *ngIf="!isLoading && product.length == 0">
                  <div class="no-data">
                      <img src="assets/no-data-6.png" alt="">
                      <p>no data found</p>
                  </div>
                  
              </div>
      
              <div class="paginator">
                  <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize" [totalRecords]="totalRecords"
                      [showFirstLastIcon]="false" [showCurrentPageReport]="true" currentPageReportTemplate="{first} - {last} of {totalRecords}"></p-paginator>
              </div>
      
        
          </div>
  
        </div>
    </div>
</div>


<div class="modal fade" id="exampleModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{ 'branch-master.headings.add' | translate }}
          <span data-dismiss="modal">
            <i class="bi bi-x-lg" (click)="cancelModel()"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
  
        <div [formGroup]="form">
  
          <div class="form-group">
            <div class="row">
              <div class="col-md-6 col-lg-6">
                <label>{{ 'branch-master.name' | translate }} <span class="required">*</span></label>
                <input formControlName="name" type="text" class="form-control">
              </div>
          
              <div class="col-md-6 col-lg-6">
                <label>{{ 'branch-master.address' | translate }} <span class="required">*</span></label>
                <input formControlName="address" type="text" class="form-control">
              </div>
              <div class="col-md-6 col-lg-6">
                <label>{{ 'branch-master.description' | translate }}</label>
                <input formControlName="description" type="text" class="form-control">
              </div>
              <div class="col-md-6 col-lg-6">
                <label>{{ 'branch-master.latitude' | translate }}</label>
                <input formControlName="latitude" type="text" class="form-control">
              </div>
              <div class="col-md-6 col-lg-6">
                <label>{{ 'branch-master.longitude' | translate }}</label>
                <input formControlName="longitude" type="text" class="form-control">
              </div>
              <div class="col-md-6 col-lg-6">
                <label>{{ 'branch-master.internal' | translate }}</label>
                <select name="" id="" formControlName="internal" class="form-control">
                  <option [ngValue]="true">True</option>
                  <option [ngValue]="false">False</option>
                </select>
              </div>
              <div class="col-md-6 col-lg-6" *ngIf="form.controls['internal'].value == 'false'">
                <label>{{ 'branch-master.belongsToType' | translate }}</label>
                <select name="" id="" formControlName="belongsToType" class="form-control">
                  <option value="Dealer">Dealer</option>
                  <option value="Distributor">Distributor</option>
                </select>
              </div>
              <div class="col-md-6 col-lg-6" *ngIf="form.controls['belongsToType'].value == 'Dealer'">
                <label>{{ 'branch-master.belongsToId' | translate }}</label>
                <select class="form-control" formControlName="belongsToId">
                  <option *ngFor="let list of dealerList" value="{{list.idealerId}}">{{list.name}}</option>
              </select>
              </div>
              <div class="col-md-6 col-lg-6" *ngIf="form.controls['belongsToType'].value == 'Distributor'">
                <label>{{ 'branch-master.belongsToId' | translate }}</label>
                <select class="form-control" formControlName="belongsToId">
                  <option *ngFor="let list of distributorList" value="{{list.idistributorId}}">{{list.name}}</option>
                </select>
              </div>
            </div>
          </div>
          
         
            <!-- <div class="form-group">
                <label>Branch Version</label>
                <input formControlName="version" type="text" class="form-control">
            </div> -->
  
            <!-- <div class="form-group">
                <label>Active status</label>
                <input  type="checkbox" formControlName="isActive" class="form-control">
            </div> -->
  
        </div>
  
   
      <div class="modal-footer">
        <button type="button" id="closeModalAdd" (click)="cancelModel()" class="btn btn-secondary" data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
        <button type="button" (click)="addBranch()" class="btn btn-primary">{{ 'generic.add' | translate }}</button>
      </div>
    </div>
  </div>
  </div>
</div>


<div class="modal fade" id="deleteModal" tabindex="-1" data-backdrop="static" aria-labelledby="deleteModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="deleteModalLabel">{{ 'generic.confirmation' | translate }}
                    <span data-dismiss="modal">
                        <i class="bi bi-x-lg" (click)="clearData()"></i>
                    </span>
                </h5>
            </div>
            <div class="modal-body">
                <p>{{ 'generic.deleteText' | translate }} <span class="delete-span">“{{recordName}}”</span>?</p>
                <div class="modal-footer">
                    <button type="button" id="closeModalDelete" (click)="clearData()" class="btn btn-secondary" data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
                    <button type="button" (click)="deleleBranch()" class="btn btn-primary">{{ 'generic.delete' | translate }}</button>
                </div>
            </div>
        </div>
    </div>
</div>





<div class="modal fade" id="viewModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{ 'branch-master.headings.detail' | translate }}
          <span data-dismiss="modal">
            <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <div class="service-data" *ngFor="let viewData of singleBranchData">
          <div class="form-group">
            <div class="row">
              <div class="col-md-6 col-lg-6">
                <label>{{ 'branch-master.name' | translate }} :</label>
                <p>{{viewData.name || '--'}}</p>
              </div>
              <div class="col-md-6 col-lg-6">
                <label>{{ 'branch-master.description' | translate }} :</label>
                <p>{{viewData.description || '--'}}</p>
              </div>
              <div class="col-md-6 col-lg-6">
                <label>{{ 'branch-master.address' | translate }} :</label>
                <p>{{viewData.address || '--'}}</p>
              </div>
              
              <div class="col-md-6 col-lg-6">
                <label>{{ 'branch-master.internal' | translate }} :</label>
                <p>{{viewData.internal || '--'}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" id="closeModalButton" class="btn btn-secondary" data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>